module.exports = __webpack_public_path__ + "static/media/background.777292e6.png";